import { render, staticRenderFns } from "./MSupport.vue?vue&type=template&id=42bc9cf3&scoped=true&"
import script from "./MSupport.vue?vue&type=script&lang=js&"
export * from "./MSupport.vue?vue&type=script&lang=js&"
import style0 from "./MSupport.vue?vue&type=style&index=0&id=42bc9cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bc9cf3",
  null
  
)

export default component.exports